export const integration = {
  name: 'integration',
  title: 'integration.menu.title',
  icon: () => import('@shared/components/icon/sidebar/icon-api-integration.vue'),
  route: { name: 'integration.api.general' },
  children: [
    {
      title: 'integration.menu.v1',
      route: { name: 'integration.api.general' }
    },
    {
      title: 'integration.menu.v2',
      route: { name: 'integration.api_v2.general' }
    },
  ]
};
